import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import React, { Component, createRef } from "react";

export default class OthersPDF extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	// downloadPdfDocument = (element) => {
	// 	const input = document.getElementById(element);
	// 	html2canvas(input).then((canvas) => {
	// 		const imgData = canvas.toDataURL("image/png");
	// 		const pdf = new jsPDF();
	// 		pdf.addImage(imgData, "JPEG", 10, 10, 190, 200);

	// 		pdf.save("Agreement.pdf");
	// 	});
	// };

	
	downloadPdfDocument = (rootElementId) => {
		const input = document.getElementById(rootElementId);
		html2canvas(input).then((canvas) => {
		  const imgData = canvas.toDataURL("image/png");
	  
		  // Calculate the width and height of the content
		  const contentWidth = canvas.width;
		  const contentHeight = canvas.height;
	  
		  // Initialize a new jsPDF object with autoSize option
		  const pdf = new jsPDF('p', 'pt', [contentWidth, contentHeight], true);
	  
		  // Add the image to the PDF document
		  pdf.addImage(imgData, "JPEG", 0, 0, contentWidth, contentHeight);
	  
		  // Save the PDF document
		  pdf.save("Agreement.pdf");
		});
	  };
	  

	render() {
		const {
			agreementDate = "",
			facilityName = "",
			name = "",
		} = this.props.pdfData;
		return (
			<div
				className="position-fixed justify-content-around py-4"
				style={{
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					zIndex: 1000,
					backgroundColor: "rgb(0 0 0 / 30%)",
					display: this.props.visible ? "flex" : "none",
				}}
			>
				<div
					className="bg-light"
					style={{ overflowY: "auto", borderRadius: 10 }}
				>
					<div
						id="pdf-others"
						className="position-relative py-2 px-5"
						style={{ width: 700 }}
					>
						<div
							className="position-absolute w-100 text-center"
							style={{ left: 0, right: 0 }}
						>
							<img src="/Picture2.png" height={60} />
						</div>
						<div className="d-flex justify-content-between">
							<img src="/Picture1.png" height={60} />
							<div className="d-flex flex-column">
								<span>Supported by:</span>
								<img src="/Picture3.png" height={20} />
							</div>
						</div>
						<div className="py-4 text-center">
							<u>
								<b>TERMS & CONDITIONS</b>
							</u>
						</div>
						<p className="text-body" style={{ fontSize: 12 }}>
							This Letter of Agreement is made on{" "}
							{moment(agreementDate).format("DD/MM/YYYY")}, by and between
							Mercy Corps (hereinafter “PR”) and the {facilityName} Staff,{" "}
							{name} (hereinafter “Focal Person”): Focal Person intends to
							render his/her services to the PR for its intervention – Rider for
							Health, and the PR intends to accept Volunteer services. Both
							parties agree as follows:
						</p>

						<p className="text-body" style={{ fontSize: 12 }}>
							<b>The focal Person shall:</b>
							<ol type="a" className="pl-5">
								<li>Participate in training on Specimen Transportation</li>
								<li>
									Update all the required recording tools for TB presumptive
									cases including Presumptive Register (GPs/BHUs), TB-04
									(RHC/BMU/PPM-Labs), and TB-05 Forms
								</li>
								<li>
									Collect specimen(s) from TB presumptive patients and ensure
									its digital record keeping using the mobile app (Riders for
									Health)
								</li>
								<li>
									Receive specimen(s) delivered by riders and maintain its cold
									chain/quality (RHC/PPM lab/BMU/GeneXpert){" "}
								</li>
								<li>
									Keep the ice packs in the available refrigerators and provide
									it to the riders along with specimen(s){" "}
								</li>
								<li>
									Insert the test results on the system and communicate it to
									the patient(s)/DFS{" "}
								</li>
							</ol>
						</p>

						<p className="text-body" style={{ fontSize: 12 }}>
							<b>Mercy Corps, Inc. shall:</b>
							<ol type="a" className="pl-5">
								<li>
									Provide an allowance payment of Rs. 25/Sample (successfully
									uploaded sample and handed over to rider / receiving samples
									from riders and uploading test results as per the requirement
									of RFH Mobile Application) as reimbursement of communication
									charges for mobile data package activation{" "}
								</li>
								<li>
									Transfer the payment (after applicable tax deduction) via bank
									on monthly basis, based upon the condition that HCF staff had
									added information of the patient(s) during the specific month
								</li>
								<li>
									Not be liable to pay for the months during which no patient(s)
									details are being added onto the system/application.
								</li>
							</ol>
						</p>

						<p className="text-body" style={{ fontSize: 12 }}>
							<b>Regional Coordinator shall:</b>
							<ol type="a" className="pl-5">
								<li>Monitor and evaluate field activities. </li>
								<li>Ensure the logistics arrangements.</li>
							</ol>
						</p>

						<p className="text-body" style={{ fontSize: 12 }}>
							<b>Confidentiality</b>
							<p className="text-body pl-5" style={{ fontSize: 12 }}>
								Neither Party shall disclose any proprietary or confidential
								information of the other Party, including, but not limited to,
								this LOA or information concerning such Party’s business or
								operations without the prior written consent of such Party.
							</p>
						</p>

						<div
							className="d-flex justify-content-center w-100 pt-4 align-items-end"
							style={{ fontSize: 12 }}
						>
							<div className="d-flex flex-column justify-content-center text-center">
								<img src="/signature.png" />
								<b className="border-top border-dark">
									<b>(Dr. Adeel Tahir, Senior Technical Advisor)</b>
								</b>
							</div>
						</div>
					</div>

					<div
						className="d-flex justify-content-end py-2 px-5"
						style={{ gap: 5 }}
					>
						<button
							className="btn btn-primary"
							onClick={() => this.downloadPdfDocument("pdf-others")}
						>
							<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
							&nbsp;Download pdf
						</button>
						<button
							className="btn btn-secondary"
							onClick={this.props.closePdfModal}
						>
							Cancel
						</button>
					</div>
				</div>
			</div>
		);
	}
}
